module.exports = __webpack_public_path__ + "img/filter-green.ee31e264.png";